import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import bgHero from '../assets/home-bg-hero.jpg';
import callCenterTeam from '../assets/call-center.jpg';
import amineImg from '../assets/Amine.jpg'
import yassineImg from '../assets/Yassine.jpg'
import rahmaImg from '../assets/Rahma.jpg'
import babacarImg from '../assets/Babacar.jpg'
import sabrinaImg from '../assets/sabrina.jpg'
import mariamImg from '../assets/mariam.jpg'
import tunisianImg from '../assets/tunisia.png'
import turkeyImg from '../assets/turkey.png'
import indianImg from '../assets/india.png'
import philippineImg from '../assets/philippines.png'
import madagImg from '../assets/madagascar.png'
import morocoImg from '../assets/morocco.png'
import callCenter from '../assets/call-center-img.jpg'

const Accueil = () => {
  const [stats, setStats] = useState({
    pays: 0,
    projets: 0,
    satisfaction: 0,
    experts: 0
  });
  const [hasAnimated, setHasAnimated] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          animateStats();
          setHasAnimated(true);
        }
      },
      { threshold: 0.5 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  const animateStats = () => {
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    const targets = {
      pays: 15,
      projets: 500,
      satisfaction: 98,
      experts: 200
    };

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setStats({
        pays: Math.floor(targets.pays * progress),
        projets: Math.floor(targets.projets * progress),
        satisfaction: Math.floor(targets.satisfaction * progress),
        experts: Math.floor(targets.experts * progress)
      });

      if (currentStep >= steps) {
        setStats(targets);
        clearInterval(timer);
      }
    }, interval);
  };

  const TeamCompositionSection = () => {
  const teamMembers = [
    { id: 1, name: 'Sabrina', age: '24 ans', role: 'conseiller clientèle à distance', image: sabrinaImg },
    { id: 2, name: 'Amine', age: '28 ans', role: 'Téléconseiller', image: amineImg },
    { id: 3, name: 'Rahma', age: '26 ans', role: 'Agent de service client', image: rahmaImg },
    { id: 4, name: 'Yassine', age: '30 ans', role: 'Chargé de relation client', image: yassineImg },
    { id: 5, name: 'Mariam', age: '25 ans', role: 'Assistante support client', image: mariamImg },
    { id: 6, name: 'Babacar', age: '27 ans', role: 'Conseiller en assistance technique', image: babacarImg }
  ];

  const benefits = [
    { icon: '💰', text: 'Salaire 1,5× supérieur au marché malgache ou tunisien' },
    { icon: '🌟', text: 'Lieu de travail digne des meilleures startups' },
    { icon: '🎁', text: 'Offsites et cadeaux à n\'en plus finir' }
  ];

  return (
    <section className="section-padding bg-gradient-to-b from-gray-50 to-white">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
          <h2 className="section-title">
            Composez votre équipe grâce à nos vidéos de présentation
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Des équipes dédiées, une communication fluide utilisant tous vos canaux. Des agents prêts à se former selon vos directives : quoi de mieux pour votre service client et service après-vente ?
          </p>
          <p className="text-base text-gray-600">
            En externalisant avec ZiExter, vous bénéficiez d'un support client efficace sur toutes les plateformes depuis Madagascar. Découvrez ce qui nous distingue des autres centres d'externalisation. On les chouchoute comme vous l'auriez fait !
          </p>
        </div>

        {/* Selection Tools */}
        <div className="grid md:grid-cols-3 gap-8 mb-16 animate-fade-in-up">
          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-primary">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Fiches profils avec vidéo de présentation</h3>
            <p className="text-gray-600">Voyez vos futurs collaborateurs en action avant même de commencer.</p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-primary animate-fade-in-up animation-delay-50">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Appel vidéo de présentation</h3>
            <p className="text-gray-600">Échangez directement pour tester l'alchimie et la motivation.</p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-primary animate-fade-in-up animation-delay-100">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Tests personnalisés</h3>
            <p className="text-gray-600">Adaptez les évaluations à vos besoins spécifiques.</p>
          </div>
        </div>

        {/* Team Grid */}
        <div className="mb-16">
         
          <div className="grid md:grid-cols-3 lg:grid-cols-3 gap-6">
            {teamMembers.map((member, index) => (
              <div key={member.id} className={`text-center group animate-fade-in-up `}>
                <div className="mb-4 rounded-lg overflow-hidden shadow-lg  bg-gray-300 flex items-center justify-center group-hover:shadow-xl transition-shadow">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-72 object-cover group-hover:scale-105 transition-transform"
                  />
                </div>
                <h4 className="font-semibold text-gray-900">{member.name}</h4>
                <p className="text-sm text-gray-600">{member.age}</p>
                <p className="text-sm text-primary font-medium">{member.role}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Why Teams Love Us */}
        <div className="bg-primary-light bg-opacity-10 rounded-lg p-12 mb-12 animate-fade-in-up">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
            Pourquoi nos équipes adorent travailler avec nous
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className={`text-center animate-fade-in-up `}>
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <p className="text-gray-700 font-medium">{benefit.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center animate-fade-in-up">
          <Link to="/contact" className="btn btn-primary btn-lg">
            Un projet ? Discutons-en
          </Link>
        </div>
           <img
  src={callCenter}
  alt="Équipe ZiExter Call Center"
  className="w-1/2 mx-auto mt-16 rounded-2xl shadow-xl"
  loading="lazy"
/>
      </div>
    </section>
  );
};

  

  return (
    <>
      <Helmet>
        <title>ZiExter - Call Center & BPO en Tunisie | Service Client Multilingue</title>
        <meta
          name="description"
          content="ZiExter : externalisation de service client, call center B2B, BPO, secrétariat médical et virtuel. Équipe multilingue basée en Tunisie. Made with 🌶️ piments."
        />
        <meta property="og:title" content="ZiExter - Call Center & BPO en Tunisie" />
        <meta property="og:description" content="Service client multilingue, call center B2B et BPO. Made with 🌶️" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://ziexter.com/" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-secondary via-secondary/95 to-primary min-h-screen flex items-center overflow-hidden pt-10 pb-14 md:pt-6 md:pb-8 lg:pt-4 lg:pb-6">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        </div>

        <div className="container-custom relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white animate-fade-in-up">
              <h1 className="font-heading text-4xl md:text-5xl lg:text-4xl font-bold mb-6 leading-tight">
                ZiExter – Votre partenaire d'externalisation, made with 🌶️ piments en Tunisie et dans le monde
              </h1>
              <p className="text-lg md:text-xl text-gray-200 mb-8 leading-relaxed">
                Service client, call center, BPO, secrétariat virtuel. Une équipe internationale, passionnée et multilingue, pour transformer chaque interaction en succès.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/services" className="btn btn-outline-white btn-md">
                  Découvrez nos services
                </Link>
                <Link to="/devis" className="btn btn-accent btn-md">
                  Demandez un devis gratuit
                </Link>
              </div>
            </div>

            <div className="lg:block animate-fade-in">
              <div className="relative">
                <div className="absolute -top-6 -left-6 w-full h-full bg-accent rounded-2xl opacity-20"></div>
                <img
                  src={bgHero}
                  alt="Équipe ZiExter - Call"
                  className="relative rounded-2xl shadow-2xl w-full"
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Pourquoi ZiExter Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Pourquoi ZiExter ? Chaque interaction compte</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="animate-fade-in">
              <img
                src={callCenterTeam}
                alt="Équipe ZiExter Call Center"
                className="rounded-2xl shadow-xl w-full"
                loading="lazy"
              />
            </div>
            <div className="flex flex-col justify-center animate-fade-in-up">
              <p className="text-xl text-gray-700 mb-6">Chez ZiExter, nous combinons :</p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <strong className="text-primary">Qualité européenne, tarifs tunisiens ou malgaches :</strong> L'efficacité française à prix compétitif.
                  </div>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <strong className="text-primary">Présence internationale :</strong> Monastir, Tunis, Madagascar, Philippines, Inde, Turquie, Maroc. Nous sommes là où vous en avez besoin.
                  </div>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <strong className="text-primary">Passion et piquant :</strong> Made with 🌶️ en Tunisie, chaque appel est traité avec dynamisme et attention.
                  </div>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <strong className="text-primary">Expertise multiculturelle :</strong> Multilingues français-anglais-arabe, formés pour chaque secteur.
                  </div>
                </li>
              </ul>
              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Link to="/contact" className="btn btn-primary">
                  Rencontrez notre équipe
                </Link>
                <Link to="/avis-clients" className="btn btn-outline">
                  Nos références clients
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services principaux Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Des solutions sur-mesure pour chaque entreprise et chaque client</h2>
            <p className="section-subtitle">
              Que vous soyez une PME française, un centre de formation ou une plateforme internationale, nous avons la solution qui vous correspond.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Link to="/services/service-client" className="card hover-lift group animate-fade-in-up">
              <div className="w-14 h-14 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Service Client – Inbound & Outbound
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Service client multicanal professionnel pour transformer vos interactions en succès.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/call-center-b2b" className="card hover-lift group animate-fade-in-up animation-delay-50">
              <div className="w-14 h-14 bg-gradient-to-br from-secondary to-primary rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Call Center B2B
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Boostez vos ventes et vos rendez-vous clients avec notre expertise B2B.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/call-center-centres-de-formation" className="card hover-lift group animate-fade-in-up animation-delay-100">
              <div className="w-14 h-14 bg-gradient-to-br from-accent to-secondary rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Call Center pour Centres de Formation
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Prise de rendez-vous, suivi des apprenants, assistance administrative.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/externalisation-appels-airbnb" className="card hover-lift group animate-fade-in-up animation-delay-150">
              <div className="w-14 h-14 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                AirBnB / Externalisation appels
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Répondez à vos clients AirBnB rapidement et efficacement.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/bpo" className="card hover-lift group animate-fade-in-up animation-delay-200">
              <div className="w-14 h-14 bg-gradient-to-br from-accent to-primary rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                BPO
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Externalisez vos processus métiers pour gagner en productivité.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/integrateur-informatique" className="card hover-lift group animate-fade-in-up animation-delay-250">
              <div className="w-14 h-14 bg-gradient-to-br from-secondary to-accent rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Intégration Informatique
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Nous prenons en charge l'intégration de vos systèmes et logiciels.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/irve-maintenance-gestion" className="card hover-lift group animate-fade-in-up animation-delay-300">
              <div className="w-14 h-14 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Maintenance et gestion pour installeur de borne electrique IRVE
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Assistance technique et gestion clients pour vos installations électriques.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/answering-service" className="card hover-lift group animate-fade-in-up animation-delay-350">
              <div className="w-14 h-14 bg-gradient-to-br from-accent to-secondary rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Secrétariat / Answering Service
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Une secrétaire virtuelle disponible 24/7 pour ne jamais manquer un appel.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/reseaux-sociaux" className="card hover-lift group animate-fade-in-up animation-delay-400">
              <div className="w-14 h-14 bg-gradient-to-br from-secondary to-primary rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Réseaux sociaux
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Animation, modération et réponses aux messages sur vos réseaux sociaux.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/secretariat-medical" className="card hover-lift group animate-fade-in-up animation-delay-450">
              <div className="w-14 h-14 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Secrétariat Médicale
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Gestion des rendez-vous, appels et dossiers patients avec professionnalisme.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/gestion-des-tickets" className="card hover-lift group animate-fade-in-up animation-delay-500">
              <div className="w-14 h-14 bg-gradient-to-br from-accent to-primary rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Gestion des tickets
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Suivi, organisation et résolution rapide de vos tickets.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>

            <Link to="/services/gardiennage-securite-privee" className="card hover-lift group animate-fade-in-up animation-delay-550">
              <div className="w-14 h-14 bg-gradient-to-br from-secondary to-accent rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3 group-hover:text-primary transition-colors">
                Gardiennage et Sécurité Privée
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                Une sécurité fiable et réactive pour vos locaux et événements.
              </p>
              <span className="text-primary font-medium inline-flex items-center">
                En savoir plus
                <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Team Composition Section - NEW */}

            <TeamCompositionSection />
          

      {/* Présence Internationale Section */}
      <section ref={statsRef} className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Une équipe internationale, proche de vos clients</h2>
            <p className="text-gray-600">
              Une présence mondiale pour être disponible là où vos clients vous attendent.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            <div className="card text-center hover-lift animate-fade-in-up">
              <div className="text-3xl mb-2 flex justify-center"> <img className="w-10 h-10 " src={tunisianImg} alt="Drapeau de la Tunisie" /> </div>
              <div className="text-2xl font-bold text-primary mb-1">{stats.pays > 0 ? 28 : 0}</div>
              <div className="text-sm text-gray-600">opérateurs à Monastir & Tunis</div>
            </div>
            <div className="card text-center hover-lift animate-fade-in-up animation-delay-50">
                <div className="text-3xl mb-2 flex justify-center"> <img className="w-10 h-10 " src={madagImg} alt="Drapeau de la Madagascar" /> </div>
              <div className="text-2xl font-bold text-primary mb-1">{stats.projets > 0 ? 12 : 0}</div>
              <div className="text-sm text-gray-600">opérateurs à Madagascar</div>
            </div>
            <div className="card text-center hover-lift animate-fade-in-up animation-delay-100">
              <div className="text-3xl mb-2 flex justify-center"> <img className="w-10 h-10 " src={philippineImg} alt="Drapeau de la Phillipine" /> </div>
              <div className="text-2xl font-bold text-primary mb-1">{stats.satisfaction > 0 ? 8 : 0}</div>
              <div className="text-sm text-gray-600">opérateurs aux Philippines</div>
            </div>
            <div className="card text-center hover-lift animate-fade-in-up animation-delay-150">
              <div className="text-3xl mb-2 flex justify-center"> <img className="w-10 h-10 " src={indianImg} alt="Drapeau de l'indie" /> </div>
              <div className="text-2xl font-bold text-primary mb-1">{stats.experts > 0 ? 4 : 0}</div>
              <div className="text-sm text-gray-600">opérateurs en Inde</div>
            </div>
            <div className="card text-center hover-lift animate-fade-in-up animation-delay-200">
              <div className="text-3xl mb-2 flex justify-center"> <img className="w-10 h-10 " src={turkeyImg} alt="Drapeau de la Turquie" /> </div>
              <div className="text-2xl font-bold text-primary mb-1">2</div>
              <div className="text-sm text-gray-600">opérateurs en Turquie</div>
            </div>
            <div className="card text-center hover-lift animate-fade-in-up animation-delay-250">
            <div className="text-3xl mb-2 flex justify-center"> <img className="w-10 h-10 " src={morocoImg} alt="Drapeau de la Maroc" /> </div>
              <div className="text-2xl font-bold text-primary mb-1">3</div>
              <div className="text-sm text-gray-600">opérateurs au Maroc</div>
            </div>
          </div>
        </div>
      </section>

      {/* Avis Clients Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Ils nous font confiance</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="card hover-lift animate-fade-in-up">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "ZiExter a révolutionné notre service client. Chaque appel est traité rapidement et avec professionnalisme. Nos clients sont ravis et notre équipe interne gagne un temps précieux. Une collaboration que nous recommandons vivement !"
              </p>
              <div className="font-semibold">Sophie Martin</div>
              <div className="text-sm text-gray-600">e-commerce, Paris</div>
            </div>

            <div className="card hover-lift animate-fade-in-up animation-delay-100">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "Grâce à ZiExter, la gestion des rendez-vous et du suivi des apprenants est devenue un vrai jeu d'enfant. L'équipe est fiable, réactive et toujours à l'écoute. Nos processus sont beaucoup plus fluides depuis leur intervention."
              </p>
              <div className="font-semibold">Marc Dubois</div>
              <div className="text-sm text-gray-600">Centre de Formation, Lyon</div>
            </div>

            <div className="card hover-lift animate-fade-in-up animation-delay-200">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "Externaliser nos appels avec ZiExter a été un vrai soulagement. Le service est impeccable et la disponibilité sans faille. Nos clients reçoivent des réponses rapides et professionnelles, ce qui renforce notre image de marque."
              </p>
              <div className="font-semibold">Claire Lefevre</div>
              <div className="text-sm text-gray-600">Plateforme AirBnB, Marseille</div>
            </div>
          </div>

          <div className="text-center mt-8">
            <Link to="/avis-clients" className="btn btn-primary">
              Voir tous les avis
            </Link>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Questions fréquentes</h2>
          </div>

          <div className="max-w-4xl mx-auto space-y-4">
            <details className="card cursor-pointer animate-fade-in-up">
              <summary className="font-semibold p-4 flex justify-between items-center">
                <span>Q : Quels services propose ZiExter ?</span>
                <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <div className="p-4 pt-0 text-gray-600">
                ZiExter propose une large gamme de services : call center inbound et outbound, BPO, secrétariat virtuel, maintenance, gestion des tickets, réseaux sociaux et bien plus. Tout est adapté à vos besoins pour simplifier vos opérations.
              </div>
            </details>

            <details className="card cursor-pointer animate-fade-in-up animation-delay-50">
              <summary className="font-semibold p-4 flex justify-between items-center">
                <span>Q : Dans quels pays êtes-vous présents ?</span>
                <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <div className="p-4 pt-0 text-gray-600">
                Nous disposons d'équipes à Monastir (Tunisie), Madagascar, Philippines, Inde, Turquie et Maroc. Cela nous permet d'offrir une présence internationale et de répondre rapidement à vos clients où qu'ils soient.
              </div>
            </details>

            <details className="card cursor-pointer animate-fade-in-up animation-delay-100">
              <summary className="font-semibold p-4 flex justify-between items-center">
                <span>Q : Vos tarifs sont-ils flexibles ?</span>
                <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <div className="p-4 pt-0 text-gray-600">
                Oui, nous proposons des solutions sur-mesure, adaptées à vos besoins et à votre budget. Chaque projet est unique, et nous vous aidons à trouver la formule la plus efficace et économique.
              </div>
            </details>

            <details className="card cursor-pointer animate-fade-in-up animation-delay-150">
              <summary className="font-semibold p-4 flex justify-between items-center">
                <span>Q : Puis-je externaliser seulement une partie de mes appels ou services ?</span>
                <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <div className="p-4 pt-0 text-gray-600">
                Absolument. Que vous souhaitiez externaliser tout votre service client ou seulement certaines tâches spécifiques, nous construisons une solution flexible qui s'intègre parfaitement à votre organisation.
              </div>
            </details>

            <details className="card cursor-pointer animate-fade-in-up animation-delay-200">
              <summary className="font-semibold p-4 flex justify-between items-center">
                <span>Q : Combien de temps faut-il pour mettre en place votre service ?</span>
                <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <div className="p-4 pt-0 text-gray-600">
                Selon vos besoins, nous pouvons démarrer très rapidement, souvent en quelques jours, avec une formation adaptée pour nos opérateurs afin de garantir un service fluide dès le lancement.
              </div>
            </details>
          </div>

          <div className="text-center mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/faq" className="btn btn-primary">
              Voir toutes les questions
            </Link>
            <Link to="/contact" className="btn btn-outline">
              Contactez-nous pour plus d'infos
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-gradient-to-r from-primary to-secondary text-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center animate-fade-in-up">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6">
              Prêt à booster votre entreprise avec ZiExter ?
            </h2>
            <p className="text-xl text-gray-100 mb-8">
              Parlez-nous de vos besoins et recevez une solution sur-mesure, rapide et efficace. Chaque appel compte, chaque interaction est un succès.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/devis" className="btn btn-accent btn-lg">
                Demandez votre devis gratuit
              </Link>
              <Link to="/contact" className="btn btn-outline-white btn-lg">
                Contactez notre équipe maintenant
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Accueil;

